// App Dashboard Page - Displays CAB details for application
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
// ADD IMPORT
import axios from "axios";
import {
  Box,
  Typography,
  Alert,
  CircularProgress,
  Button,
  Grid,
  Card,
  CardContent,
  Breadcrumbs,
  Link,
  Paper,
  Avatar,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TextField,
  MenuItem,
  TableRow,
} from "@mui/material";
import {
  ArrowBack as ArrowBackIcon,
  Dashboard as DashboardIcon,
  Business as BusinessIcon,
  Science as ScienceIcon,
  Badge as BadgeIcon,
  LockOpen as UnfreezeIcon,
  Timeline as TimelineIcon,
  Schedule as ScheduleIcon,
  TrendingUp as TrendingUpIcon,
  Description as DescriptionIcon,
  Person2Outlined,
  VisibilityOutlined as ScrutinyIcon,
  History as HistoryIcon,
  Dangerous as InActiveIcon,
  Person,
  AccountBalance as AccountBalanceIcon,
  ChangeCircle as ChangeCircleIcon,
} from "@mui/icons-material";
import DoApiService from "../../../services/DoApiService";
import { decryptAppId, decryptText, encryptAppId, encryptText } from "../../../utils/encryption";
import PaymentDetails from "./PaymentDetails";
import ReportsDetails from "./ReportsDetails";
import DealingOfficerDetails from "./DealingOfficerDetails";
import EmailNotificationDetails from "./EmailNotificationDetails";
import AssessorDetailsView from "../../JD/application/AssessorDetailsView";
import ExpertCommentsReissueWorkflow from "../../Medical/applicationForm/ExpertCommentsReissueWorkflow";
import FileUploadComponent from "../../../components/FileUploadComponent";
import CommonAPIService from "../../../services/commonAPIService";

const AppDashboard = () => {
  // State management
  const [cabDetails, setCabDetails] = useState(null);
  const [dealingOfficer, setDealingOfficer] = useState(null);
  const [contactPersons, setContactPersons] = useState([]); // Changed to array for multiple contacts
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openOfficerDialog, setOpenOfficerDialog] = useState(false);
  const [openContactDialog, setOpenContactDialog] = useState(false);
  const [assessorsData, setAssessorsData] = useState([]);
  const [rejectedRemarks, setRejectedRemarks] = useState([]);
  const [openInactiveDialog, setOpenInactiveDialog] = useState(false);
  const [inactiveForwardTo, setInactiveForwardTo] = useState("");
  const [inactiveReason, setInactiveReason] = useState("");
  const [inactivePassword, setInactivePassword] = useState("");
  const [inactiveFile, setInactiveFile] = useState(null);

  const [inactiveUploadedFile, setInactiveUploadedFile] = useState(null);
  const [fileUploadKey, setFileUploadKey] = useState(Date.now());
  // ADD STATE WITH OTHER useState
  const [ceoList, setCeoList] = useState([]);
  const [openExtendDialog, setOpenExtendDialog] = useState(false);
  const [extendDays, setExtendDays] = useState("");
  const [extendReason, setExtendReason] = useState("");
  const [extendForwardTo, setExtendForwardTo] = useState("");
  const [inactiveRemarksData, setInactiveRemarksData] = useState([]);

  // Request for Form 11 states
  const [openForm11Dialog, setOpenForm11Dialog] = useState(false);
  const [form11RequestTo, setForm11RequestTo] = useState("");
  const [form11Reason, setForm11Reason] = useState("");
  const [form11Submitting, setForm11Submitting] = useState(false);
  const [form11Status, setForm11Status] = useState({ hasEntry: false, isAccept: null, acceptReason: null });

  // Assessor Logistics States
  const [agreementData, setAgreementData] = useState(null);
  const [isVisibleAssessorLogistic, setIsVisibleAssessorLogistic] = useState(false);

  // Dialog open/close handlers
  const handleOpenOfficerDialog = () => setOpenOfficerDialog(true);
  const handleCloseOfficerDialog = () => setOpenOfficerDialog(false);
  const handleOpenContactDialog = () => setOpenContactDialog(true);
  const handleCloseContactDialog = () => setOpenContactDialog(false);

  // Scrutiny button handler
  const handleScrutinyClick = () => {
    if (!appId || !orgId) {
      console.error('AppId or OrgId not available for scrutiny');
      return;
    }

    try {
      // Encrypt the parameters
      const encryptedAppIdParam = encryptAppId(appId);
      const encryptedOrgIdParam = encryptText(orgId);

      // Navigate to medical/laboratory-details with encrypted parameters
      if (cabDetails.assessmentTypeId === 11 || cabDetails.assessmentTypeId === 12) {
        navigate(`/main/medical/lab-staff-additional?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}`);
      } else if (cabDetails.assessmentTypeId === 5 || cabDetails.assessmentTypeId === 13 || cabDetails.assessmentTypeId === 17) {
        navigate(`/main/medical/discipline?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}`);
      } else if (cabDetails.labTypeId === 2) {
        navigate(`/main/calibration/laboratory-details?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}`);
      } else if (cabDetails.labTypeId === 1) {
        navigate(`/main/Testing/laboratory-details?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}`);
      } else {
        navigate(`/main/medical/laboratory-details?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}`);
      }
    } catch (error) {
      console.error('Error encrypting parameters for scrutiny:', error);
    }
  };

  const handleMarkForInactive = () => {
    setOpenInactiveDialog(true);
  };

  const handleCloseInactiveDialog = () => {
    setOpenInactiveDialog(false);
  };

  const handleOpenExtendDialog = () => {
    setOpenExtendDialog(true);
  };

  const handleCloseExtendDialog = () => {
    setOpenExtendDialog(false);
  };
  const handleSubmitExtend = async () => {

    try {

      if (!extendDays) {
        alert("Please enter days");
        return;
      }

      if (!extendReason.trim()) {
        alert("Please enter reason");
        return;
      }

      if (!extendForwardTo) {
        alert("Please select Forward To");
        return;
      }

      const payload = {
        appId,
        orgId: localStorage.getItem("orgId"),
        extendedDays: extendDays,
        reason: extendReason,
        forwardTo: extendForwardTo
      };

      console.log(payload);

      const response = await DoApiService.extendInactiveDays(payload);

      if (response.success) {

        alert(response.message || "Application Extended Successfully");

        setOpenExtendDialog(false);

        setExtendDays("");
        setExtendReason("");
        setExtendForwardTo("");

        loadCABDetails();

      } else {

        alert(response.message || "Failed to submit");

      }

    } catch (error) {

      console.error("Extend Submit Error:", error);

      alert("Something went wrong");

    }
  };

  const handleSubmitInactive = async () => {
    try {
      if (!inactiveForwardTo) {
        alert("Please select Forward To");
        return;
      }

      if (!inactiveReason.trim()) {
        alert("Please enter reason");
        return;
      }

      if (!inactivePassword.trim()) {
        alert("Please enter password");
        return;
      }

      /* PASSWORD VERIFY */
      const verifyResponse = await axios.post(
        `${process.env.REACT_APP_API_URL || "http://localhost:5000/api"}/auth/verify-password`,
        {
          orgId: localStorage.getItem("orgId") || "",
          password: inactivePassword
        }
      );

      if (!verifyResponse.data.success) {
        alert("Invalid password. Please try again.");
        return;
      }

      /* MAIN API CALL */
      const payload = {
        appId: appId,
        orgId: localStorage.getItem("orgId"),
        forwardTo: inactiveForwardTo,
        reason: inactiveReason,
        password: inactivePassword,
        filePath: inactiveUploadedFile?.s3Url || "",
        fileName: inactiveUploadedFile?.s3Url || ""
      };

      const response = await DoApiService.markInactive(payload);

      if (response.success) {
        alert(response.message || "Application InActive Successfully");

        setOpenInactiveDialog(false);
        setInactiveForwardTo("");
        setInactiveReason("");
        setInactivePassword("");
        setInactiveUploadedFile(null);
        setFileUploadKey(Date.now());

        loadCABDetails();
      } else {
        alert(response.message || "Failed to submit");
      }

    } catch (error) {
      console.error("Inactive Submit Error:", error);
      alert("Invalid password or something went wrong");
    }
  };


  const getInactiveRemark = async () => {
    if (!appId) {
      console.log("AppId is Not Available");
      return;
    }

    try {

      const response = await DoApiService.getinactiveremark({
        appId: parseFloat(appId),
      });

      if (response.success == true) {
        setInactiveRemarksData(response.inactivedata || []);
      }

    } catch (error) {
      console.log("Inactive Remark Error", error);
    }
  };


  const handleOpenForm11Dialog = () => setOpenForm11Dialog(true);

  const handleCloseForm11Dialog = () => {
    setOpenForm11Dialog(false);
    setForm11RequestTo("");
    setForm11Reason("");
  };

  const handleSubmitForm11Request = async () => {
    if (!form11RequestTo) {
      alert("Please select a JD");
      return;
    }
    if (!form11Reason.trim()) {
      alert("Please enter a reason");
      return;
    }
    try {
      setForm11Submitting(true);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL || "http://localhost:5000/api"}/do/request-form11`,
        {
          appId,
          requestBy: localStorage.getItem("orgId"),
          requestTo: form11RequestTo,
          requestReason: form11Reason.trim()
        }
      );
      if (response.data.success) {
        alert(response.data.message || "Request submitted successfully");
        handleCloseForm11Dialog();
      } else {
        alert(response.data.message || "Failed to submit request");
      }
    } catch (error) {
      console.error("Form 11 Request Error:", error);
      alert("Something went wrong");
    } finally {
      setForm11Submitting(false);
    }
  };

  const handleScrutinyAddOnApplicationClick = () => {
    if (!appId || !orgId) {
      console.error('AppId or OrgId not available for scrutiny');
      return;
    }
    try {
      // Encrypt the parameters
      const encryptedAppIdParam = encryptAppId(appId);
      const encryptedOrgIdParam = encryptText(orgId);
      const encryptedLabTypeId = encryptText(cabDetails.labTypeId || '');
      const assessmentTypeId = cabDetails.assessmentTypeId || '';
      if (assessmentTypeId === 8) {
        navigate(`/main/add-on/change-name?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&labTypeId=${encryptedLabTypeId}`);
      } else if (assessmentTypeId === 9) {
        navigate(`/main/add-on/acquisition-merger?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&labTypeId=${encryptedLabTypeId}`);
      } else if (assessmentTypeId === 10) {
        navigate(`/main/add-on/change-incab-permises?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&labTypeId=${encryptedLabTypeId}`);
      } else if (assessmentTypeId === 18) {
        navigate(`/main/add-on/ilac?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&labTypeId=${encryptedLabTypeId}`);
      }
    } catch (error) {
      console.error('Error encrypting parameters for scrutiny:', error);
    }
  };

  const handleInactiveFileUploadChange = (fileData, uploadData) => {
    setInactiveUploadedFile(uploadData);
  };

  const handleUnfreezeClick = () => {
    if (!appId || !orgId) {
      console.error('AppId or OrgId not available for unfreeze');
      return;
    }

    try {
      // Encrypt the parameters
      const encryptedAppIdParam = encryptAppId(appId);
      const encryptedOrgIdParam = encryptText(orgId);

      // Navigate to medical/laboratory-details with encrypted parameters
      navigate(`/main/do/unfreezeApplication?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}`);
    } catch (error) {
      console.error('Error encrypting parameters for unfreeze:', error);
    }
  };

  // Audit Trail button handler
  const handleAuditTrailClick = () => {
    if (!appId || !orgId) {
      console.error('AppId or OrgId not available for audit trail');
      return;
    }

    try {
      // Encrypt the parameters
      const encryptedAppIdParam = encryptAppId(appId);
      const encryptedOrgIdParam = encryptText(orgId);
      const encryptedObservation = encryptText('true');

      // Navigate to audit trail page with encrypted parameters
      navigate(`/main/do/audit-trail?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&observation=${encryptedObservation}`);
    } catch (error) {
      console.error('Error encrypting parameters for audit trail:', error);
    }
  };




  const handleAssessorAllotmentClick = () => {
    if (!appId || !orgId) {
      console.error('AppId or OrgId not available for assessor allotment');
      return;
    }

    try {
      // Encrypt the parameters
      const encryptedAppIdParam = encryptAppId(appId);
      const encryptedOrgIdParam = encryptText(orgId);
      const cabStage = encryptText(cabDetails.stage || '');

      // Navigate to assessor allotment page with encrypted parameters
      navigate(`/main/do/assessor-allotment?appId=${encryptedAppIdParam}&orgId=${encryptedOrgIdParam}&cabStage=${cabStage}`);
    } catch (error) {
      console.error('Error encrypting parameters for audit trail:', error);
    }
  };

  // Handle Form 11
  // const handleForm11 = () => {
  //   const encryptedappid = encryptAppId(appId.toString());
  //   const encryptedorgid = encryptText(orgId.toString());
  //   const form11url = `/main/do/form11?appId=${encryptedappid}&orgId=${encryptedorgid}`;
  //   window.open(form11url, "_blank");
  // };

  //Handle Form 11
  const handleForm11 = async () => {
    try {
      const response = await CommonAPIService.getAssessmentSendToNABLDate(appId);
      if (response.success && response.data) {
        if (response.data.isDisplayNew) {
          const url = `/main/do/form11-new?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}`;
          navigate(url);
        } else {
          const url = `/main/do/form11?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}`;
          navigate(url);
        }
      } else {
        const url = `/main/do/form11?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}`;
        navigate(url);
      }
    } catch (error) {
      console.error("Form11 navigation error:", error);
      const url = `/main/do/form11?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}`;
      navigate(url);
    }
  };

  const decisionProcess = async () => {
    const url = `/main/do/ac-process?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}`;
    navigate(url);
  }
  // Router hooks
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Get encrypted parameters from URL
  const encryptedAppId = searchParams.get("appId");
  const encryptedOrgId = searchParams.get("orgId");
  const encryptedLabTypeId = searchParams.get("labTypeId");

  // Decrypt parameters
  const appId = encryptedAppId ? decryptAppId(encryptedAppId) : null;
  const orgId = encryptedOrgId ? decryptText(encryptedOrgId) : null;
  const labTypeId = encryptedLabTypeId ? decryptText(encryptedLabTypeId) : null;

  // Load dealing officer details (mode 31)
  const loadDealingOfficer = useCallback(async () => {
    if (!appId) return;

    try {
      const response = await DoApiService.getAllotmentDetails({
        mode: 31,
        appId: parseFloat(appId),
      });

      if (response.success && response.data.length > 0) {
        setDealingOfficer(response.data[0]); // Take first officer
      }
    } catch (err) {
      console.error("Load dealing officer error:", err);
    }
  }, [appId]);

  // Load contact person details (mode 27)
  const loadContactPerson = useCallback(async () => {
    if (!appId) return;

    try {
      const response = await DoApiService.getAllotmentDetails({
        mode: 27,
        appId: parseFloat(appId),
      });

      if (response.success && response.data.length > 0) {
        setContactPersons(response.data); // Store all contact persons (lab head + CEO details)
      }
    } catch (err) {
      console.error("Load contact person error:", err);
    }
  }, [appId]);

  // Load rejected remarks
  const loadRejectedRemarks = useCallback(async () => {
    if (!appId) return;

    try {
      const response = await DoApiService.getRejectedRemarks({
        appId: parseFloat(appId),
      });

      if (response.success && response.data.length > 0) {
        setRejectedRemarks(response.data);
      }
    } catch (err) {
      console.error("Load rejected remarks error:", err);
    }
  }, [appId]);

  // Load CAB details on page load (equivalent to .NET getCABDetailAll)
  const loadCABDetails = useCallback(async () => {
    if (!appId) {
      setError("Invalid application ID. Please check the URL.");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Call API to get CAB details (mode 100 equivalent)
      const response = await DoApiService.getCABDetails({
        appId: parseFloat(appId), // Convert to double as per .NET code
      });

      if (response.success) {
        setCabDetails(response.data);

        // Store in session equivalent (localStorage)
        localStorage.setItem("AppDashboard_AppId", appId);
        localStorage.setItem("AppDashboard_OrgId", orgId || "");
        localStorage.setItem("AppDashboard_LabTypeId", labTypeId || "");

        // Load additional details
        await Promise.all([loadDealingOfficer(), loadContactPerson(), loadRejectedRemarks()]);
      } else {
        throw new Error(response.message || "Failed to load CAB details");
      }
    } catch (err) {
      setError(`Error loading CAB details: ${err.message}`);
      console.error("Load CAB details error:", err);
    } finally {
      setLoading(false);
    }
  }, [appId, orgId, labTypeId, loadDealingOfficer, loadContactPerson]);

  // Load assessor allotment data using mode 5
  const loadAssessorAllotmentData = useCallback(async () => {
    if (!appId) {
      setError("Invalid application ID. Please check the URL.");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Call API to get assessor allotment details (mode 5 - AssessorAllotment_New)
      const response = await DoApiService.getAssessorAllotmentDetails9({
        mode: 64,
        appId: parseFloat(appId),
      });

      if (response.success) {
        setAssessorsData(response.data || []);
        // Log capacity information for debugging
        response.data?.forEach((assessor, index) => {
          console.log(`Assessor ${index + 1}:`, {
            name: assessor.assessorName || assessor.name,
            id: assessor.allotedToId,
            capacity: assessor.capacity,
            fullData: assessor
          });
        });
      } else {
        throw new Error(response.message || "Failed to load assessor allotment details");
      }
    } catch (err) {
      setError(`Error loading assessor allotment details: ${err.message}`);
      console.error("Load assessor allotment error:", err);
      // Set empty data on error
      setAssessorsData([]);
    } finally {
      setLoading(false);
    }
  }, [appId]);

  // ADD FUNCTION

  const loadCeoList = useCallback(async () => {
    if (!appId) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/ceolist`,
        {
          params: {
            appid: appId,
            usertypeid: localStorage.getItem('userTypeId'),
          },
        }
      );

      setCeoList(response.data.ceo || []);
    } catch (error) {
      console.error("CEO List Error:", error);
    }
  }, [appId]);


  const loadForm11Status = useCallback(async () => {
    if (!appId) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL || "http://localhost:5000/reactApi/api"}/do/request-form11-status`,
        { params: { appId } }
      );
      setForm11Status({
        hasEntry: response.data.hasEntry === true,
        isAccept: response.data.isAccept ?? null,
        acceptReason: response.data.acceptReason ?? null,
      });
    } catch (error) {
      console.error("Form11 status error:", error);
    }
  }, [appId]);

  const loadAgreement = useCallback(async () => {
        if (!appId || !orgId) return;
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/assessor-logistic/agreement/${orgId}/${appId}`
            );
            if (response.data.success) {
                setAgreementData(response.data.data);
            } 
        } catch (err) {
            console.error('Error loading agreement:', err);
        } 
  }, [appId, orgId]);

const checkDOChangeStatus = useCallback(async () => {
  try {
    const { data } = await axios.get(
      `${process.env.REACT_APP_API_URL}/assessor-logistic/check-do-change/${appId}`
    );
    if (data.success) {
      setIsVisibleAssessorLogistic(data.isDOChange);
    }
  } catch (error) {
    console.error("Error checking DO change status:", error);
  }
  }, [appId]);

  // Load data when component mounts
  useEffect(() => {
    loadCABDetails();
    loadAssessorAllotmentData();
    loadCeoList();
    getInactiveRemark();
    loadForm11Status();
    loadAgreement();
    checkDOChangeStatus();
  }, [loadCABDetails, loadAssessorAllotmentData, loadRejectedRemarks, loadCeoList, loadForm11Status, loadAgreement, checkDOChangeStatus]);

  const handleOpenAssessorLogistics = () => {
        if (agreementData && agreementData?.PdfUrl) {
            window.open(agreementData.PdfUrl, '_blank');
        } else {
            // Optionally navigate to create agreement page if PDF doesn't exist
            // For now, just show a message
            alert('Assessor Logistics agreement PDF not available.');
        }
    };
   
  const handleAssessorLogisticClick = () => {
        const url = `/main/do/assessor-logistics?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}`;
        navigate(url);
    }  

  // Handle back navigation
  const handleBackClick = () => {
    navigate(-1); // Go back to previous page
  };
  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleDateString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh",
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" sx={{ ml: 2 }}>
          Loading Dealing Officer Dashboard...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
        <Button
          variant="outlined"
          onClick={handleBackClick}
          startIcon={<ArrowBackIcon />}
        >
          Go Back
        </Button>
      </Box>
    );
  }

  if (!cabDetails) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="h6" color="textSecondary">
          No CAB details found for this application
        </Typography>
        <Button
          variant="outlined"
          onClick={handleBackClick}
          startIcon={<ArrowBackIcon />}
          sx={{ mt: 2 }}
        >
          Go Back
        </Button>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f8fafc",
        pt: 2,
        pb: 4,
      }}
    >
      {/* Header with Gradient Background */}
      <Paper
        elevation={0}
        sx={{
          background: "linear-gradient(135deg, #00024c 0%, #1a2b6b 100%)",
          color: "white",
          borderRadius: 0,
          mb: 3,
        }}
      >
        <Box sx={{ px: 3, py: 3 }}>
          {/* Breadcrumbs */}
          <Breadcrumbs
            sx={{
              mb: 2,
              "& .MuiBreadcrumbs-separator": { color: "rgba(255,255,255,0.7)" },
            }}
          >
            <Link
              component="button"
              variant="body2"
              onClick={handleBackClick}
              sx={{
                textDecoration: "none",
                color: "rgba(255,255,255,0.8)",
                "&:hover": { color: "white" },
              }}
            >
              Applications
            </Link>
            <Typography variant="body2" sx={{ color: "white" }}>
              Dashboard
            </Typography>
          </Breadcrumbs>

          {/* Header Content */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Avatar
                sx={{
                  bgcolor: "rgba(255,255,255,0.2)",
                  mr: 2,
                  width: 56,
                  height: 56,
                }}
              >
                <DashboardIcon sx={{ fontSize: 28 }} />
              </Avatar>
              <Box>
                <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                  {cabDetails.laboratoryName || cabDetails.labName}
                </Typography>

                <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
                  {cabDetails.applicationNo} • {cabDetails.labType} •
                  <Chip
                    label={`Standard: ${cabDetails.standard}`}
                    variant="outlined"
                    size="small"
                    sx={{
                      ml: 1,
                      color: "white",
                      borderColor: "rgba(255,255,255,0.7)",
                    }}
                  />
                  <Chip
                    icon={<Person2Outlined sx={{ color: "white !important" }} />}
                    label="Contact Persons"
                    variant="outlined"
                    size="small"
                    onClick={handleOpenContactDialog}
                    sx={{
                      ml: 1,
                      color: "white",
                      borderColor: "rgba(255,255,255,0.7)",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.1)",
                        borderColor: "white",
                      },
                    }}
                  />
                  <Chip
                    icon={<Person2Outlined sx={{ color: "white !important" }} />}
                    label="Dealing Officer"
                    variant="outlined"
                    size="small"
                    onClick={handleOpenOfficerDialog}
                    sx={{
                      ml: 1,
                      color: "white",
                      borderColor: "rgba(255,255,255,0.7)",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "rgba(255,255,255,0.1)",
                        borderColor: "white",
                      },
                    }}
                  />
                </Typography>
              </Box>
            </Box>

            <Button
              variant="outlined"
              startIcon={<ArrowBackIcon />}
              onClick={handleBackClick}
              sx={{
                borderColor: "rgba(255,255,255,0.3)",
                color: "white",
                "&:hover": {
                  borderColor: "white",
                  backgroundColor: "rgba(255,255,255,0.1)",
                },
              }}
            >
              Back
            </Button>
          </Box>
        </Box>
      </Paper>

      <Box sx={{ px: 3 }}>
        {/* Key Metrics Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* Current Stage */}
          <Grid item xs={12} sm={6}>
            <Card
              sx={{
                background: "linear-gradient(135deg, #fe8f4fff 0%, #fe3b00ff 100%)",
                color: "white",
                borderRadius: 3,
                boxShadow: "0 8px 32px rgba(79, 172, 254, 0.25)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: "0 12px 40px rgba(79, 172, 254, 0.35)",
                },
              }}
            >
              <CardContent sx={{ p: 3 }}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2,
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "rgba(255,255,255,0.2)",
                      width: 48,
                      height: 48,
                    }}
                  >
                    <TimelineIcon sx={{ fontSize: 24 }} />
                  </Avatar>
                  <ScheduleIcon sx={{ fontSize: 20, opacity: 0.7 }} />
                </Box>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, fontSize: 15, mb: 1 }}
                >
                  Current Stage
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  {cabDetails.stage || "N/A"} <br />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, fontSize: 15, mt: 1 }}
                  >
                    Last Updated
                  </Typography>{" "}
                  {formatDate(cabDetails.lastUpdated)} <br />
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, fontSize: 15, mt: 1 }}
                  >
                    Pending At
                  </Typography>{" "}
                  {cabDetails.PendingAt || "N/A"}
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 700, fontSize: 15, mt: 1 }}
                  >
                    Submission Date
                  </Typography>{" "}
                  {formatDate(cabDetails.submissionDate)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          {dealingOfficer && dealingOfficer.orgId === localStorage.getItem("orgId") && (
            <Grid item xs={12} lg={6}>
              <Card
                sx={{
                  borderRadius: 3,
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                  border: "1px solid #e2e8f0",
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                    <Avatar
                      sx={{
                        bgcolor: "success.main",
                        mr: 2,
                        width: 40,
                        height: 40,
                      }}
                    >
                      <DescriptionIcon />
                    </Avatar>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 600, color: "text.primary" }}
                    >
                      Quick Actions
                    </Typography>
                  </Box>

                  <Grid container spacing={2}>
                    <Grid item xs={12} sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                      
                       {agreementData && agreementData.IsDO === true && (
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<DescriptionIcon />}
                          onClick={handleOpenAssessorLogistics}
                        >
                          Assessor Logistics Agreement
                        </Button>
                       )}
                      {isVisibleAssessorLogistic && (
                        <Button
                          variant="contained"
                          color="secondary"
                          startIcon={<ChangeCircleIcon />}
                          onClick={handleAssessorLogisticClick}
                        >
                          Assessor Logistics
                        </Button>
                      )}

                      {/* Scrutiny Button - Only show for stages 15, 15b */}
                      {(cabDetails?.CurrentStage === '15' || cabDetails?.CurrentStage === '15b' || cabDetails?.CurrentStage === '15bb') && (
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<ScrutinyIcon />}
                          onClick={handleScrutinyAddOnApplicationClick}
                          sx={{
                            py: 1.5,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
                            backgroundColor: "#1976d2",
                            "&:hover": {
                              backgroundColor: "#1565c0",
                            },
                          }}
                        >
                          Scrutiny Application
                        </Button>
                      )}
                      {/* Scrutiny Button - Only show for stages 18, 18b, or 18c */}
                      {(cabDetails?.CurrentStage === '18' || cabDetails?.CurrentStage === '18b' || cabDetails?.CurrentStage === '18c') && (
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<ScrutinyIcon />}
                          onClick={handleScrutinyClick}
                          sx={{
                            py: 1.5,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
                            backgroundColor: "#1976d2",
                            "&:hover": {
                              backgroundColor: "#1565c0",
                            },
                          }}
                        >
                          Scrutiny Application
                        </Button>
                      )}
                      {(cabDetails?.CurrentStage === '19' ||
                        cabDetails?.CurrentStage === '19a' ||
                        cabDetails?.CurrentStage === '19b' ||
                        cabDetails?.CurrentStage === '19c' ||
                        cabDetails?.CurrentStage === '19d' ||
                        cabDetails?.CurrentStage === '19e' ||
                        cabDetails?.CurrentStage === '19f' ||
                        cabDetails?.CurrentStage === '19h' ||
                        cabDetails?.CurrentStage === '20'
                      ) && (
                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<UnfreezeIcon />}
                            onClick={handleUnfreezeClick}
                            sx={{
                              py: 1.5,
                              borderRadius: 2,
                              textTransform: "none",
                              fontWeight: 600,
                              boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
                              backgroundColor: "#1976d2",
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                            }}
                          >
                            UnFreeze Application
                          </Button>
                        )}
                      {/* Assessor Allotment Button */}
                      {(cabDetails?.CurrentStage === '19' ||
                        cabDetails?.CurrentStage === '19a' ||
                        cabDetails?.CurrentStage === '19b' ||
                        cabDetails?.CurrentStage === '19c' ||
                        cabDetails?.CurrentStage === '19d' ||
                        cabDetails?.CurrentStage === '19e' ||
                        cabDetails?.CurrentStage === '19f' ||
                        cabDetails?.CurrentStage === '19h' ||
                        cabDetails?.CurrentStage === '20'
                      ) && (
                          <Button
                            variant="contained"
                            color="primary"
                            startIcon={<Person />}
                            onClick={handleAssessorAllotmentClick}
                            sx={{
                              py: 1.5,
                              borderRadius: 2,
                              textTransform: "none",
                              fontWeight: 600,
                              boxShadow: "0 4px 12px rgba(25, 118, 210, 0.2)",
                              backgroundColor: "#1976d2",
                              "&:hover": {
                                backgroundColor: "#1565c0",
                              },
                            }}
                          >
                            Assessor Allotment
                          </Button>
                        )}
                      {(cabDetails?.CurrentStage === '8' || cabDetails?.CurrentStage === '8g' || inactiveRemarksData?.length > 0) ? (
                        null
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          startIcon={<InActiveIcon />}
                          onClick={handleMarkForInactive}
                        >
                          Mark For InActive
                        </Button>
                      )}
                      {(cabDetails?.CurrentStage === '8' || inactiveRemarksData?.length > 0) && (
                        <Button
                          variant="contained"
                          color="warning"
                          onClick={handleOpenExtendDialog}
                        >
                          Extend Days
                        </Button>
                      )}


                      {/* Request for Form 11: show when no entry, or entry rejected (isAccept=2) */}
                      {(!form11Status.hasEntry || form11Status.isAccept === 2) && (
                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                          <Button
                            variant="contained"
                            startIcon={<DescriptionIcon />}
                            onClick={handleOpenForm11Dialog}
                            sx={{
                              py: 1.5,
                              borderRadius: 2,
                              textTransform: "none",
                              fontWeight: 600,
                              backgroundColor: "#2e7d32",
                              "&:hover": { backgroundColor: "#1b5e20" },
                            }}
                          >
                            Request for Form 11
                          </Button>
                        </Box>
                      )}
                      {/* Form 11: show only when entry approved (isAccept=1) */}
                      {form11Status.hasEntry && form11Status.isAccept === 1 && (
                        <Button
                          variant="contained"
                          startIcon={<DescriptionIcon />}
                          onClick={() => handleForm11()}
                          sx={{
                            py: 1.5,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            backgroundColor: "#2e7d32",
                            "&:hover": { backgroundColor: "#1b5e20" },
                          }}
                        >
                          Form 11
                        </Button>
                      )}

                      {(cabDetails?.CurrentStage === "6b" ||
                        cabDetails?.CurrentStage === "6d" ||
                        cabDetails?.CurrentStage === "6a" || //as per haribabu sir
                        cabDetails?.CurrentStage === "6e" ||
                        cabDetails?.CurrentStage === "6f" ||
                        cabDetails?.CurrentStage === "7" ||
                        cabDetails?.CurrentStage === "7a" ||
                        cabDetails?.CurrentStage === "7b" ||
                        cabDetails?.CurrentStage === "7c" ||
                        cabDetails?.CurrentStage === "7d" ||
                        cabDetails?.CurrentStage === "7e" ||
                        cabDetails?.CurrentStage === "7f" ||
                        cabDetails?.CurrentStage === "7g" ||
                        cabDetails?.CurrentStage === "7h" ||
                        cabDetails?.CurrentStage === "11b" ||
                        cabDetails?.CurrentStage === "12" ||
                        cabDetails?.CurrentStage === "12a" ||
                        cabDetails?.CurrentStage === "12b" ||
                        cabDetails?.CurrentStage === "13a" ||
                        cabDetails?.CurrentStage === "13b" ||
                        cabDetails?.CurrentStage === "13c" ||
                        cabDetails?.CurrentStage === "13d" ||
                        cabDetails?.CurrentStage === "13e" ||
                        cabDetails?.CurrentStage === "11f" ||
                        cabDetails?.CurrentStage === "11g" ||
                        cabDetails?.CurrentStage === "13") && assessorsData.length === 0 && (
                          <Button
                            variant="contained"
                            startIcon={<DescriptionIcon />}
                            onClick={() => decisionProcess()}
                            sx={{
                              py: 1.5,
                              borderRadius: 2,
                              textTransform: "none",
                              fontWeight: 600,
                              backgroundColor: "#2e7d32",
                              "&:hover": { backgroundColor: "#1b5e20" },
                            }}
                          >
                            Decision Process
                          </Button>
                        )}

                      {(cabDetails?.CurrentStage === "7g" ||
                        cabDetails?.CurrentStage === "12" ||
                        cabDetails?.CurrentStage === "12a" ||
                        cabDetails?.CurrentStage === "12b" ||
                        cabDetails?.CurrentStage === "13e") && (
                          <Button
                            variant="contained"
                            onClick={() => {
                              const url = `/main/do/advisory?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&labTypeId=${encryptText(labTypeId || "3")}`;
                              navigate(url);
                            }}
                            sx={{
                              py: 1.5,
                              borderRadius: 2,
                              textTransform: "none",
                              fontWeight: 600,
                              backgroundColor: "#ed6c02",
                              "&:hover": { backgroundColor: "#e65100" },
                            }}
                          >
                            Advisory/Showcause
                          </Button>
                        )}

                      {/* {(cabDetails?.CurrentStage === "13e" ||
                        cabDetails?.CurrentStage === "7h") && (
                          <Button
                            variant="contained"
                            onClick={() => {
                              const url = `/main/do/showcause?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&labTypeId=${encryptText(labTypeId || "3")}`;
                              navigate(url);
                            }}
                            sx={{
                              py: 1.5,
                              borderRadius: 2,
                              textTransform: "none",
                              fontWeight: 600,
                              backgroundColor: "#d32f2f",
                              "&:hover": { backgroundColor: "#b71c1c" },
                            }}
                          >
                            Show Cause
                          </Button>
                        )} */}

                      {/* Audit Trail Button */}

                      <Button
                        variant="contained"
                        color="secondary"
                        startIcon={<HistoryIcon />}
                        onClick={handleAuditTrailClick}
                        sx={{
                          py: 1.5,
                          borderRadius: 2,
                          textTransform: "none",
                          fontWeight: 600,
                          boxShadow: "0 4px 12px rgba(156, 39, 176, 0.2)",
                          backgroundColor: "#9c27b0",
                          "&:hover": {
                            backgroundColor: "#7b1fa2",
                          },
                        }}
                      >
                        Audit Trail
                      </Button>

                      {/* Facility Location Approval Button - Only for labTypeId 1 and 2 */}
                      {(labTypeId === '1' || labTypeId === '2') && cabDetails?.CurrentStage === '20' && (
                        <Button
                          variant="contained"
                          startIcon={<AccountBalanceIcon />}
                          onClick={() => {
                            const url = `/main/do/facility-location-approval?appId=${encryptAppId(appId)}&orgId=${encryptText(orgId)}&labTypeId=${encryptText(labTypeId)}`;
                            navigate(url);
                          }}
                          sx={{
                            py: 1.5,
                            borderRadius: 2,
                            textTransform: "none",
                            fontWeight: 600,
                            boxShadow: "0 4px 12px rgba(76, 175, 80, 0.2)",
                            backgroundColor: "#4caf50",
                            "&:hover": {
                              backgroundColor: "#388e3c",
                            },
                          }}
                        >
                          Facility Location Acceptance
                        </Button>
                      )}

                      {
                        (cabDetails?.CurrentStage === '20' ||
                          cabDetails?.CurrentStage === '21')
                        && (
                          <>
                            <Button
                              variant="contained"
                              color="secondary"
                              startIcon={<HistoryIcon />}
                              onClick={() => {
                                if (assessorsData.length > 0 && assessorsData[0].NAF1) {
                                  window.open(assessorsData[0].NAF1, "_blank", "noopener,noreferrer");
                                }
                              }}
                              sx={{
                                py: 1.5,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                boxShadow: "0 4px 12px rgba(156, 39, 176, 0.2)",
                                backgroundColor: "#9c27b0",
                                "&:hover": {
                                  backgroundColor: "#7b1fa2",
                                },
                              }}
                            >
                              NAF 1
                            </Button>
                            {(labTypeId === '1' || labTypeId === '2') && (
                              <Button
                                variant="contained"
                                color="secondary"
                                startIcon={<HistoryIcon />}
                                onClick={() => {
                                  const url = `/main/laboratory/form8?appId=${encryptAppId(
                                    appId
                                  )}`;
                                  window.open(url, "_blank", "noopener,noreferrer");
                                }}
                                sx={{
                                  py: 1.5,
                                  borderRadius: 2,
                                  textTransform: "none",
                                  fontWeight: 600,
                                  boxShadow: "0 4px 12px rgba(156, 39, 176, 0.2)",
                                  backgroundColor: "#9c27b0",
                                  "&:hover": {
                                    backgroundColor: "#7b1fa2",
                                  },
                                }}
                              >
                                Form 8
                              </Button>
                            )}
                            <Button
                              variant="contained"
                              color="secondary"
                              startIcon={<HistoryIcon />}
                              onClick={() => {
                                const url = `/main/laboratory/form9?appId=${encryptAppId(
                                  appId
                                )}`;
                                window.open(url, "_blank", "noopener,noreferrer");
                              }}
                              sx={{
                                py: 1.5,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                boxShadow: "0 4px 12px rgba(156, 39, 176, 0.2)",
                                backgroundColor: "#9c27b0",
                                "&:hover": {
                                  backgroundColor: "#7b1fa2",
                                },
                              }}
                            >
                              Form 9
                            </Button>
                          </>
                        )}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </Grid>
          )}
          {inactiveRemarksData?.length > 0 && (
            <Grid item xs={12} sx={{ mb: 3 }}>

              <Typography
                variant="h6"
                sx={{ fontWeight: 700, mb: 2 }}
              >
                Inactive Remarks Details
              </Typography>

              {inactiveRemarksData.map((item, index) => (

                <Card
                  key={index}
                  sx={{
                    mb: 2,
                    borderRadius: 3,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                    borderLeft: "5px solid #f44336",
                  }}
                >
                  <CardContent>

                    <Grid container spacing={2}>

                      <Grid item xs={12} md={6}>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700 }}
                        >
                          Reason
                        </Typography>

                        <Typography variant="body2">
                          {item.Reason || "N/A"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700 }}
                        >
                          Inactive Date
                        </Typography>

                        <Typography variant="body2">
                          {formatDate(item.InactiveDate)}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700 }}
                        >
                          JD Remarks
                        </Typography>

                        <Typography variant="body2">
                          {item.JointDirectors_Remarks || "N/A"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 700, mb: 1 }}
                        >
                          Uploaded File
                        </Typography>

                        {item.Files ? (
                          <Button
                            variant="outlined"
                            size="small"
                            onClick={() =>
                              window.open(
                                item.Files,
                                "_blank"
                              )
                            }
                          >
                            View File
                          </Button>
                        ) : (
                          <Typography variant="body2">
                            No File Uploaded
                          </Typography>
                        )}
                      </Grid>

                    </Grid>

                  </CardContent>
                </Card>

              ))}

            </Grid>
          )}

          {form11Status.isAccept === 2 && form11Status.acceptReason && (
            <Grid item xs={12} sx={{ mb: 3 }}>

              <Typography
                variant="h6"
                sx={{ fontWeight: 700, mb: 2 }}
              >
                Form 11 Request Remarks Details
              </Typography>


              <Card
                sx={{
                  mb: 2,
                  borderRadius: 3,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
                  borderLeft: "5px solid #f44336",
                }}
              >
                <CardContent>

                  <Grid container spacing={2}>

                    <Grid item xs={12} md={6}>
                      <Typography
                        variant="subtitle2"
                        sx={{ fontWeight: 700 }}
                      >
                        Reason
                      </Typography>

                      <Typography variant="body2">
                        {form11Status.acceptReason || "N/A"}
                      </Typography>
                    </Grid>

                  </Grid>

                </CardContent>
              </Card>


            </Grid>
          )}
          {/* Rejected Remarks Card */}
          {rejectedRemarks.length > 0 && (
            <Grid item xs={12} md={6}>
              <Card
                sx={{
                  background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                  color: "white",
                  borderRadius: 3,
                  boxShadow: "0 8px 32px rgba(245, 158, 11, 0.25)",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    transform: "translateY(-4px)",
                    boxShadow: "0 12px 40px rgba(245, 158, 11, 0.35)",
                  },
                }}
              >
                <CardContent sx={{ p: 3 }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 2,
                    }}
                  >
                    <Avatar
                      sx={{
                        bgcolor: "rgba(255,255,255,0.2)",
                        width: 48,
                        height: 48,
                        mr: 2,
                      }}
                    >
                      <DescriptionIcon sx={{ fontSize: 24 }} />
                    </Avatar>
                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 700, fontSize: 18 }}
                    >
                      Rejection Remarks
                    </Typography>
                  </Box>
                  <TableContainer sx={{ maxHeight: 400 }}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell
                            sx={{
                              bgcolor: "rgba(255,255,255,0.2)",
                              color: "white",
                              fontWeight: 700,
                              fontSize: 14,
                            }}
                          >
                            Rejected By
                          </TableCell>
                          <TableCell
                            sx={{
                              bgcolor: "rgba(255,255,255,0.2)",
                              color: "white",
                              fontWeight: 700,
                              fontSize: 14,
                            }}
                          >
                            Reason
                          </TableCell>
                          <TableCell
                            sx={{
                              bgcolor: "rgba(255,255,255,0.2)",
                              color: "white",
                              fontWeight: 700,
                              fontSize: 14,
                            }}
                          >
                            Date
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rejectedRemarks.map((remark, index) => (
                          <TableRow
                            key={index}
                            sx={{
                              "&:hover": {
                                bgcolor: "rgba(255,255,255,0.1)",
                              },
                            }}
                          >
                            <TableCell sx={{ color: "white", fontSize: 13 }}>
                              {remark.RemarkByName || "N/A"}
                            </TableCell>
                            <TableCell sx={{ color: "white", fontSize: 13 }}>
                              {remark.Remark || "N/A"}
                            </TableCell>
                            <TableCell sx={{ color: "white", fontSize: 13 }}>
                              {formatDate(remark.InsertDate || "")}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </CardContent>
              </Card>
            </Grid>
          )}
        </Grid>

        {/* Main Content Cards */}
        <Grid container spacing={3} sx={{ mb: 4 }}>
          {/* Dealing Officer Details Button */}
          <Grid item xs={12} lg={4}>
            {/* Dialog for Dealing Officer Information */}
            <Dialog
              open={openOfficerDialog}
              onClose={handleCloseOfficerDialog}
              maxWidth="xs"
              fullWidth
            >
              <DialogTitle>Dealing Officer Information</DialogTitle>
              <DialogContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                  <Avatar
                    sx={{
                      bgcolor: "primary.main",
                      mr: 2,
                      width: 40,
                      height: 40,
                    }}
                  >
                    <BadgeIcon />
                  </Avatar>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: "text.primary" }}
                  >
                    Dealing Officer
                  </Typography>
                </Box>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Box
                      sx={{ p: 2, bgcolor: "#f0f9ff", borderRadius: 2, mb: 2 }}
                    >
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: 1,
                        }}
                      >
                        Officer Name
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 500, mt: 0.5 }}
                      >
                        {dealingOfficer?.name || "Not assigned"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box
                      sx={{ p: 2, bgcolor: "#f0f9ff", borderRadius: 2, mb: 2 }}
                    >
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: 1,
                        }}
                      >
                        Email
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 500, mt: 0.5 }}
                      >
                        {dealingOfficer?.email || "N/A"}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={12}>
                    <Box sx={{ p: 2, bgcolor: "#f0f9ff", borderRadius: 2 }}>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{
                          fontWeight: 600,
                          textTransform: "uppercase",
                          letterSpacing: 1,
                        }}
                      >
                        Contact
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 500, mt: 0.5 }}
                      >
                        {dealingOfficer?.mobile ||
                          dealingOfficer?.email ||
                          "N/A"}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseOfficerDialog}
                  color="primary"
                  variant="outlined"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>

          {/* Contact Person Details Button */}
          <Grid item xs={12} lg={4}>
            {/* Dialog for Contact Person Information */}
            <Dialog
              open={openContactDialog}
              onClose={handleCloseContactDialog}
              maxWidth="md"
              fullWidth
            >
              <DialogTitle>Contact Person Information</DialogTitle>
              <DialogContent>
                <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
                  <Avatar
                    sx={{
                      bgcolor: "secondary.main",
                      mr: 2,
                      width: 40,
                      height: 40,
                    }}
                  >
                    <BusinessIcon />
                  </Avatar>
                  <Typography
                    variant="h6"
                    sx={{ fontWeight: 600, color: "text.primary" }}
                  >
                    Laboratory Contacts
                  </Typography>
                </Box>

                {contactPersons.length > 0 ? (
                  <Grid container spacing={3}>
                    {contactPersons.map((contact, index) => (
                      <Grid item xs={12} md={6} key={index}>
                        <Card
                          variant="outlined"
                          sx={{
                            height: '100%',
                            border: contact.isPrimary ? '2px solid #1976d2' : '1px solid #e0e0e0'
                          }}
                        >
                          <CardContent>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                              <Avatar
                                sx={{
                                  bgcolor: contact.recordType === 'lab_head_contact' ? 'primary.main' : 'success.main',
                                  mr: 2,
                                  width: 32,
                                  height: 32,
                                }}
                              >
                                <Person2Outlined sx={{ fontSize: 18 }} />
                              </Avatar>
                              <Box>
                                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                  {contact.recordType === 'lab_head_contact' ? 'Contact Person Details' : 'CEO Details'}
                                </Typography>
                                {/* {contact.isPrimary && (
                                  <Chip 
                                    label="Primary" 
                                    size="small" 
                                    color="primary" 
                                    sx={{ mt: 0.5 }} 
                                  />
                                )} */}
                              </Box>
                            </Box>

                            <Box sx={{ mb: 2 }}>
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{
                                  fontWeight: 600,
                                  textTransform: "uppercase",
                                  letterSpacing: 0.5,
                                }}
                              >
                                Name
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ fontWeight: 500, mt: 0.5 }}
                              >
                                {contact.name || "Not available"}
                              </Typography>
                            </Box>


                            {contact.email && (
                              <Box sx={{ mb: 2 }}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  sx={{
                                    fontWeight: 600,
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                  }}
                                >
                                  Email
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 500, mt: 0.5 }}
                                >
                                  {contact.email}
                                </Typography>
                              </Box>
                            )}

                            {contact.mobile && (
                              <Box sx={{ mb: 2 }}>
                                <Typography
                                  variant="caption"
                                  color="text.secondary"
                                  sx={{
                                    fontWeight: 600,
                                    textTransform: "uppercase",
                                    letterSpacing: 0.5,
                                  }}
                                >
                                  Mobile
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 500, mt: 0.5 }}
                                >
                                  {contact.mobile}
                                </Typography>
                              </Box>
                            )}

                          </CardContent>
                        </Card>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 3 }}>
                    <Typography variant="body1" color="text.secondary">
                      No contact information available
                    </Typography>
                  </Box>
                )}
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseContactDialog}
                  color="secondary"
                  variant="outlined"
                >
                  Close
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        </Grid>
        {(cabDetails.CurrentStage === "3b" ||
          cabDetails.CurrentStage === "15d" ||
          cabDetails.CurrentStage === "19" ||
          cabDetails.CurrentStage === "19a" ||
          cabDetails.CurrentStage === "19b" ||
          cabDetails.CurrentStage === "19c" ||
          cabDetails.CurrentStage === "19d" ||
          cabDetails.CurrentStage === "19e" ||
          cabDetails.CurrentStage === "19f" ||
          cabDetails.CurrentStage === "20" ||
          cabDetails.CurrentStage === "21" ||
          cabDetails.CurrentStage === "19h" ||
          cabDetails.CurrentStage === "6a" ||
          cabDetails.CurrentStage === '7a') &&
          (cabDetails.assessmentTypeId === 11 ||
            cabDetails.assessmentTypeId === 12 ||
            cabDetails.assessmentTypeId === 13 ||
            cabDetails.assessmentTypeId === 17) && (
            <Box
              sx={{
                maxHeight: '400px',
                overflowY: 'auto',
                overflowX: 'hidden',
                mb: 3,
                p: 2,
                border: '1px solid #e0e0e0',
                borderRadius: 2,
                backgroundColor: '#fff',
              }}
            >
              <ExpertCommentsReissueWorkflow
                applicationStage={cabDetails.CurrentStage}
                assessmentTypeId={cabDetails.assessmentTypeId}
                getOrgId={() => orgId}
                getAppId={() => appId}
              />
            </Box>
          )}
        {(cabDetails.CurrentStage === "19a" ||
          cabDetails.CurrentStage === "19b" ||
          cabDetails.CurrentStage === "19c" ||
          cabDetails.CurrentStage === "19d" ||
          cabDetails.CurrentStage === "19e" ||
          cabDetails.CurrentStage === "19f" ||
          cabDetails.CurrentStage === "20" ||
          cabDetails.CurrentStage === "21" ||
          cabDetails.CurrentStage === "19h" ||
          cabDetails.CurrentStage === "6a" ||
          cabDetails.CurrentStage === "6b" ||
          cabDetails.CurrentStage === "6c" ||
          ///////Ac Process Stages///////
          cabDetails.CurrentStage === "6d" ||
          cabDetails.CurrentStage === "6e" ||
          cabDetails.CurrentStage === "6f" ||
          cabDetails.CurrentStage === '7' ||
          cabDetails.CurrentStage === '7a' ||
          cabDetails.CurrentStage === '7b' ||
          cabDetails.CurrentStage === '7c' ||
          cabDetails.CurrentStage === '7d' ||
          cabDetails.CurrentStage === '7e' ||
          cabDetails.CurrentStage === '7f' ||
          cabDetails.CurrentStage === '7g' ||
          cabDetails.CurrentStage === '7h' ||
          cabDetails.CurrentStage === '11b' ||
          cabDetails.CurrentStage === '12' ||
          cabDetails.CurrentStage === '12a' ||
          cabDetails.CurrentStage === '12b' ||
          cabDetails.CurrentStage === '13' ||
          cabDetails.CurrentStage === '13a' ||
          cabDetails.CurrentStage === '13b' ||
          cabDetails.CurrentStage === '13c' ||
          cabDetails.CurrentStage === '13d' ||
          cabDetails.CurrentStage === '13e' ||
          cabDetails.CurrentStage === '11f' ||
          cabDetails.CurrentStage === '11g' ||
          cabDetails.CurrentStage === '20a' ||
          cabDetails.CurrentStage === '13') ? (
          <Grid item xs={12} >
            <AssessorDetailsView appId={encryptedAppId} orgId={encryptedOrgId} type="DO" stage={cabDetails.CurrentStage} assessorsData={assessorsData} />
          </Grid>
        ) : (
          null
        )}
        {/* Reports Details Section */}
        <ReportsDetails appId={appId} orgId={orgId} labTypeId={labTypeId} />

        {/* Payment Details Section */}
        <PaymentDetails appId={appId} />

        {/* Email Notification Details Section */}
        {localStorage.getItem("labTypeIds")?.split(",").map(id => id.trim()).includes("3") && (
          <EmailNotificationDetails appId={appId} isCab={false} />
        )}

        <Dialog
          open={openInactiveDialog}
          onClose={handleCloseInactiveDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            Mark InActive To This Application
          </DialogTitle>

          <DialogContent dividers>

            <TextField
              select
              fullWidth
              margin="normal"
              label="Forward To"
              value={inactiveForwardTo}
              onChange={(e) => setInactiveForwardTo(e.target.value)}
            >
              <MenuItem value="">-- Select --</MenuItem>

              {ceoList.map((item, index) => (
                <MenuItem
                  key={index}
                  value={item.OrgId || item.id}
                >
                  {item.Name || item.name}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              fullWidth
              multiline
              rows={4}
              margin="normal"
              label="Reason For InActive"
              value={inactiveReason}
              onChange={(e) => setInactiveReason(e.target.value)}
            />

            <Box sx={{ mt: 2 }}>
              <FileUploadComponent
                key={`inactiveFile-${fileUploadKey}`}
                fieldName="inactiveFile"
                label="Upload File"
                orgId={localStorage.getItem("orgId") || "laboratory"}
                section="inactive-documents"
                accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                maxSize={10}
                onChange={handleInactiveFileUploadChange}
                initialFile={inactiveUploadedFile}
                localDeleteOnly={false}
                required={false}
                disabled={false}
              />
            </Box>

            <TextField
              fullWidth
              type="password"
              margin="normal"
              label="Enter Your Password"
              value={inactivePassword}
              onChange={(e) => setInactivePassword(e.target.value)}
            />

          </DialogContent>

          <DialogActions>
            <Button onClick={handleCloseInactiveDialog}>
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleSubmitInactive}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>

        {/* Request for Form 11 Dialog */}
        <Dialog open={openForm11Dialog} onClose={handleCloseForm11Dialog} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ fontWeight: 700, color: "#2e7d32" }}>
            Request for Form 11
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2} sx={{ mt: 0.5 }}>
              <Grid item xs={12}>
                <TextField
                  select
                  fullWidth
                  label="Select JD"
                  value={form11RequestTo}
                  onChange={(e) => setForm11RequestTo(e.target.value)}
                  required
                >
                  <MenuItem value="">-- Select JD --</MenuItem>
                  {ceoList.map((item, index) => (
                    <MenuItem key={index} value={item.id}>
                      {item.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  multiline
                  rows={4}
                  label="Reason"
                  value={form11Reason}
                  onChange={(e) => setForm11Reason(e.target.value)}
                  required
                  placeholder="Enter reason for Form 11 request"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions sx={{ p: 2, gap: 1 }}>
            <Button onClick={handleCloseForm11Dialog} disabled={form11Submitting}>
              Cancel
            </Button>
            <Button
              variant="contained"
              onClick={handleSubmitForm11Request}
              disabled={form11Submitting}
              sx={{ backgroundColor: "#2e7d32", "&:hover": { backgroundColor: "#1b5e20" } }}
            >
              {form11Submitting ? "Submitting..." : "Send"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openExtendDialog}
          onClose={handleCloseExtendDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>
            Extend the Application
          </DialogTitle>

          <DialogContent dividers>

            <TextField
              fullWidth
              margin="normal"
              label="Days to extend *"
              value={extendDays}
              onChange={(e) => setExtendDays(e.target.value)}
            />

            <TextField
              fullWidth
              multiline
              rows={4}
              margin="normal"
              label="Reason *"
              value={extendReason}
              onChange={(e) => setExtendReason(e.target.value)}
            />

            <TextField
              select
              fullWidth
              margin="normal"
              label="Forward To *"
              value={extendForwardTo}
              onChange={(e) => setExtendForwardTo(e.target.value)}
            >
              <MenuItem value="">-- Select --</MenuItem>

              {ceoList.map((item, index) => (
                <MenuItem
                  key={index}
                  value={item.OrgId || item.id}
                >
                  {item.Name || item.name}
                </MenuItem>
              ))}
            </TextField>

          </DialogContent>

          <DialogActions>
            <Button onClick={handleCloseExtendDialog}>
              Cancel
            </Button>

            <Button
              variant="contained"
              onClick={handleSubmitExtend}
            >
              Submit
            </Button>
          </DialogActions>
        </Dialog>


      </Box>
    </Box>
  );
};

export default AppDashboard;
